export const placeholder = {
  id: null,
  sprites: {
    front_default: "/pikachu-outline.jpeg",
  },
  name: "???",
  types: [{ type: { type: { name: "" } } }],
  abilities: [{ ability: { ability: { name: "" } } }],
};
